import React from 'react'

import FeaturesHero from 'components/shared/FeaturesHero'
import SliceManager from 'components/shared/SliceManager'
import PreviewBanner from 'components/shared/PreviewBanner'
import AlgoliaSearch from 'components/shared/AlgoliaSearch'
import LogoContent from 'components/shared/CardWithArrowLink/LogoContent'
import { CardWithArrowLinkProps } from 'components/shared/CardWithArrowLink'

import { getDataDependencies } from 'services/api'
import algolia from 'src/services/algolia'
import { fetchFacets } from 'src/services/algoliaHelpers'
import fetchSingleType from 'src/lib/Strapi/fetchSingleType'
import { algoliaFeaturesAdapter } from 'adapters/features'
import { revalidating } from 'src/lib/staticProps'

const index = 'features'
const Features = ({
  pageData: { slices, featuresHero },
  preview,
  articles,
  facets,
}) => {
  const customCardProps = CardWithArrowLinkProps.customCardProps

  return (
    <>
      {preview && <PreviewBanner />}
      {featuresHero && <FeaturesHero {...featuresHero} />}
      {articles && <AlgoliaSearch
        index={index}
        initialAlgolia={articles}
        adapter={algoliaFeaturesAdapter}
        placeholder="Search a feature"
        labelType="Capabilities"
        pathname="/features"
        facets={facets}
        fullSearch={false}
        customCardComponent={(props) => (
          <LogoContent {...props} className={[props.level]} />
        )}
        customCardProps={customCardProps}
        isAdvancedFilter
      />}
      {slices && <SliceManager slices={slices} />}
    </>
  )
}

const featureFacets = {
  tag: {
    label: 'Capabilities',
    multi: true,
  },
}

export async function getStaticProps({ preview = null }) {
  const articles = await algolia(index).search('', {
    hitsPerPage: 12,
    page: 0,
    filters: 'publishedAt:true',
  })

  const facets = await fetchFacets([index, featureFacets])
  const pageData = await fetchSingleType('feature', preview)

  const extendedData = await getDataDependencies(pageData)

  return revalidating({
    props: { pageData: extendedData, preview, articles, facets },
  })
}

export default Features
